<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Listing the company Services page
@Last modified by:   tom
@Last modified time: 2019-06-12T17:20:54+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>

  <c-page id="prices"
        :title="$t('prices.title')"
        :jbheader="$t('prices.header')"
        :jblead="$t('prices.lead')"
        :jbimage="assetUrl('img/prices/consult.jpg')"
        jbvariant="info">

    <!-- Act quickly -->

    <h2 class="text-secondary" v-html="$t('prices.puck.title')" />
    <b-row>
      <b-col md="8">
        <p v-html="$t('prices.puck.slot')"/>
      </b-col>
      <b-col>
        <!-- Preorder button -->
        <b-button
          to="/puck/preorder"
          size=""
          variant="warning"
          class="mb-4 float-right"
          v-html="$t('intro.preorder.button') "/>
      </b-col>
    </b-row>

    <!-- Price of Pucks & Bundels -->

    <b-card-group id="offerpanes" deck class="mt-4">
      <b-card
        v-for="f in ['puck_set', 'free_plan', 'standard_plan']"
        :key = "f"
        :class="cardGroup($t(`prices.puck.${f}._cardgroup`, 'en'))"
        :header-bg-variant="$t(`prices.puck.${f}._color`)"
        :header-text-variant="$t(`prices.puck.${f}._color`) | contrastColor"
        :header="$t(`prices.puck.${f}.header`)"
        :footer-bg-variant="$t(`prices.puck.${f}._color`)"
        :footer-text-variant="$t(`prices.puck.${f}._color`) | contrastColor"
        :footer="$t(`prices.puck.${f}.note`)"
      >
        <!-- <h5 v-html="$t(`prices.puck.${f}.title`)"/> -->

        <!-- list with bundle advantages -->
        <uli :labelkey="`prices.puck.${f}`" size="sm" icon="angle-right" color="warning" />

        <!-- Puck selector -->
        <div v-if="$te(`prices.puck.${f}.pack.label`,'en')">
          <div id="pre-pack-selector" class="mb-2" v-html="$t( `prices.puck.${f}.pack.label`)" />
          <b-row align-v="center" no-gutters>
            <b-col>
              <b-button-group id="pack-selector" size="sm">
                <div v-for="i in 5" :key = "i">
                  <b-button
                    v-if="$te(`prices.puck.${f}.pack.${i}`,'en')"
                    :pressed="isSelected(f,i)"
                    variant="outline-info"
                    @click="selectSet(f,i)"
                    v-html="$t(`prices.puck.${f}.pack.${i}.contains`)"
                  />
                </div>
              </b-button-group>
            </b-col>
            <b-col>
              <div class="converted_currency pl-2">
                {{ $t( `prices.puck.${f}.pack.${selectedSet[f]}._eur`) | formatCurrency(currency, rate, true) }}<small style="vertical-align: super;">*</small>
              </div>
            </b-col>
          </b-row>
          <div
            id="post-pack-selector"
            class="mt-2"
            v-html="$t( `prices.puck.${f}.pack.${selectedSet[f]}.note`)"/>

          <!-- Selected Image -->
          <lzimg
            v-if="$te(`prices.puck.${f}.pack.${selectedSet[f]}._img`, 'en')"
            :src="assetUrl('img/prices/' + $t(`prices.puck.${f}.pack.${selectedSet[f]}._img`))"
            class="card-image pt-2"

            fluid
            width="700"
            height="350" />

        </div>

      </b-card>
    </b-card-group>
    <br>

    <!-- ###  Service comparision -->
    <br>
    <h2 class="text-secondary" v-html="$t('services.compare.title')" />
    <p v-html="$t('services.compare.intro')" />

    <table id="service-comparision" class="table table-hover" style="border: 1px solid #ddd;">
      <thead class="bg-info text-white">
        <tr>
          <th v-for="col in 3" :key="col" v-html="$t(`services.table.header.${col}`)"/>
        </tr>
      </thead>
      <tbody>
        <!-- for now maximal 15 services  -->
                  <!-- v-if="$te(`services.table.row.${row}.label`, 'en')" -->
        <tr
          v-for="row in nrServices"
          :key="row"
          style="cursor: pointer;"
          @click="involkeScrollService(row)">

          <th scope="row" class="text-primary" @click="$bvModal.show(`service-modal${row}`)">
            <icon :name="$t(`services.table.row.${row}._icon`)" scale="1.1" style="width: 1em;"/>
            <span class="ml-2" v-html="$t(`services.table.row.${row}.label`)"/>
          </th>

          <td v-if="$t(`services.table.row.${row}._plan`).includes('free')" class="text-center">
            <icon name="check" class="text-success" style="display: inline-block;" scale="1.2"/>
          </td>
          <td v-else/>

          <td v-if="$t(`services.table.row.${row}._plan`).includes('care')" class="text-center">
            <icon name="check" class="text-success" style="display: inline-block;" scale="1.2"/>
          </td>
          <td v-else/>

          <!-- *** MODAL *** Put the modal somewhere -->
          <b-modal
            :id="`service-modal${row}`"
            :title="$t(`services.table.row.${row}.label`)"
            size="lg"
            header-bg-variant="secondary"
            header-text-variant="white"
            ok-only>
            <b-row class="mb-2">
              <b-col v-if="$te(`services.table.row.${row}._img`, 'en')" md="3">
                <!-- possible ._img if we have label in the lang file-->
                <lzimg :src="assetUrl('img/services/' + $t(`services.table.row.${row}._img`))"
                       zoom-modal
                       fluid
                       width="500"
                       height="275"/>
              </b-col>
              <b-col>
                <h2 v-if="$te(`services.table.row.${row}.title`,'en')" class="text-secondary" v-html="$t(`services.table.row.${row}.title`)"/>

              </b-col>
            </b-row>
            <p class="card-text">
              <span v-html="$t(`services.table.row.${row}.slot`)"/>
              <!-- possible .link -->
              <router-link
                v-if="$te(`services.table.row.${row}.link._href`,'en')"
                :to="$t(`services.table.row.${row}.link._href`)"
                v-html="$t(`services.table.row.${row}.link.text`)"/>
            </p>
            <i v-html="$t(`services.table.row.${row}.block`)" />
          </b-modal>

        </tr>
      </tbody>
      <tfoot class="bg-info text-white">
        <tr>
          <th v-for="col in 3" :key="col"/>
        </tr>
      </tfoot>
    </table>
    <!-- Sub text  -->
    <p class="mt-2"><small v-html="$t('prices.puck.note')" /></p>

  </c-page>

</template>

<script>
import Conf from '@/config/settings'
import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

export default {
  name: 'PuckPrices',
  filters: {
    contrastColor: (color) => {
      if (!color) return 'dark'
      return ['primary', 'secondary', 'dark', 'info'].includes(color) ? 'white' : 'dark'
    }
  },
  data: function () {
    return {
      folder: '/downloads/resources/',
      languages: ['en', 'nl', 'de', 'fr', 'es', 'ru'],
      // what pack did we select in a set
      selectedSet: { type: Array, default: [0, 1, 1] }, // array starts at 0, dont use
      nrPlans: 3
    }
  },
  computed: {
    nrServices: function () {
      let n = 1
      while (this.$te(`services.table.row.${n}.label`, 'en')) {
        n++
      }
      return n - 1
    },
    currency: function () {
      return this.$store.getters['app/setting']('currency')
    },
    rate: function () {
      return Conf.currency.rates[this.$store.getters['app/setting']('currency')].rate
    }
  },
  methods: {
    selectSet: function (f, i) {
      this.$set(this.selectedSet, f, i)
      // NOTE: this.selectedSet[f] = i  is not reactive, see https://vuejs.org/v2/guide/reactivity.html
    },
    // whenever question changes, this function will run
    isSelected: function (f, i) {
      // console.log(`is?  f=${f} i=${i} and ${this.selectedSet[f]} === ${i}`)
      if (!this.selectedSet[f]) {
        this.selectSet(f, i)
      }
      return this.selectedSet[f] === i
    },
    // introduce card groups
    cardGroup: function (cardOrient) {
      let returnClass = ''
      // console.log(`orient = ${cardOrient}`)
      if (cardOrient.includes('start')) { returnClass += 'start-group-card ' }
      if (cardOrient.includes('end')) { returnClass += 'end-group-card ' }
      return returnClass
    },
    involkeScrollService: function (row) {
      invokeScrollEvent('Service ' + row, 200)
    }
  }
}

</script>

<style lang="scss" scoped>

  #prices {
    #token-table {
      font-size: 0.9em;
    }
    #pre-pack-selector,
    #post-pack-selector {
      // padding-top: 5px;
      line-height: 1.1rem;
      font-size: .8em;
      //margin-bottom: 2px;
      //display: inline-block;
    }

    #pack-selector {
      width: 100%;
      .btn {
        // width: 33%;
        min-width: 3em;
      }
    }
    .converted_currency {
      display: block;
      color: $secondaryMedium;
      font-weight: bold;
      font-size: 1.1em;
    }
    .post_curr {
      color: $secondaryMedium;
      // position a bit higher:
      display: inline-block;
      display: -moz-inline-box;
      -moz-box-orient: vertical;
      vertical-align: top;
    }

    // the price panes
    #offerpanes {
      .card {
        border: 1px solid $primaryDark;
      }
      .card-header {
        // min-height: 4rem;
        font-size: 1.4em;
        line-height: 1.1em;
      }
      .card-footer {
        font-size: .9em;
      }
      .note {

      }

      @media (max-width: 599px) {
        // to group cards, only on x-small screens
        .card-footer {
          display: none;
        }
        .start-group-card {
          margin-bottom: 0;
          border-bottom-color: #bbb !important;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          .card-header {
            border-top-right-radius: 0;
          }

        }
        .end-group-card {
          margin-top: -1px;
          border-top-color: #bbb !important;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          .card-header {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
          }
        }
      }
      @media (min-width:600px) {
        // to group cards, not on x-small screens
        .start-group-card {
          margin-right: 0;
          border-right-color: #bbb !important;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          .card-header {
            border-top-right-radius: 0;
          }
          .card-footer {
            border-bottom-right-radius: 0;
          }
        }
        .end-group-card {
          margin-left: -1px;
          border-left-color: #bbb !important;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          .card-header {
            border-top-left-radius: 0;
          }
          .card-footer {
            border-bottom-left-radius: 0;
          }
        }
      }
    }  // offerpanes

    #service-comparision {
      $sctab_top_bott_pad: 0.4em;
      tr {
        font-size: 0.85em;
      }
      th {
        padding: $sctab_top_bott_pad 0 $sctab_top_bott_pad 0.4em;
        span {
          text-decoration: underline;
          text-decoration-color: #aaa;
        }
      }
      td  {
        padding: $sctab_top_bott_pad;
      }
    }

  }

</style>
